import { useLocation, Link } from "react-router-dom";
import { CheckCircle, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";

export function SuccessPage() {
    const location = useLocation();
    const state = location.state as { orderId?: string; phone?: string } | null;

    // Fallback if accessed directly without state (though mostly for dev)
    const orderId = state?.orderId || "ORDER-12345";

    return (
        <div className="min-h-[80vh] flex flex-col items-center justify-center py-12 px-4 animate-fade-in bg-muted/20">
            <Card className="w-full max-w-md text-center shadow-lg border-primary/10">
                <CardHeader className="space-y-4 pb-2">
                    <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-green-100">
                        <CheckCircle className="h-10 w-10 text-green-600" />
                    </div>
                    <div>
                        <CardTitle className="text-2xl font-bold text-green-700">Order Successful!</CardTitle>
                        <p className="text-muted-foreground mt-2">
                            Thank you for your purchase. Your order has been placed successfully.
                        </p>
                    </div>
                </CardHeader>
                <CardContent className="space-y-6">
                    <div className="rounded-lg bg-muted/50 p-4 border border-dashed border-primary/20">
                        <p className="text-sm text-muted-foreground mb-1">Order ID</p>
                        <p className="text-xl font-mono font-bold tracking-wider select-all">{orderId}</p>
                    </div>

                    <div className="space-y-2">
                        <p className="text-sm">
                            We have sent a confirmation to your phone.
                            <br />
                            You can track your order status anytime via WhatsApp.
                        </p>
                    </div>

                    <Button
                        className="w-full bg-green-600 hover:bg-green-700 h-12 text-lg shadow-md hover:shadow-lg transition-all"
                        onClick={() => {
                            const message = `Hello, I want to track my order #${orderId}`;
                            window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank');
                        }}
                    >
                        <MessageCircle className="mr-2 h-5 w-5" />
                        Track on WhatsApp
                    </Button>
                </CardContent>
                <CardFooter className="flex flex-col gap-3 pt-2">
                    <Link to="/" className="w-full">
                        <Button variant="outline" className="w-full">
                            Continue Shopping
                        </Button>
                    </Link>
                </CardFooter>
            </Card>
        </div>
    );
}
